import React from "react";
import { TitleBar, Loading } from "@shopify/app-bridge-react";
import {
  LegacyCard,
  EmptyState,
  Layout,
  Page,
  SkeletonBodyText,
  Text,
  AlphaStack,
  Banner,
} from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import { QrIndex } from "../components";
import { useAppQuery } from "../hooks";

export default function Home({ user: user }) {
  const navigate = useNavigate();

  const {
    data: QRCodes,
    isLoading,
    isRefetching,
  } = useAppQuery({
    url: "/api/shopify/qr/list",
  });

  const qrCodesMarkup = QRCodes?.length ? (
    <QrIndex QRCodes={QRCodes} loading={isRefetching} />
  ) : null;

  const loadingMarkup = isLoading ? (
    <LegacyCard sectioned>
      <Loading />
      <SkeletonBodyText />
    </LegacyCard>
  ) : null;

  const emptyStateMarkup =
    !isLoading && !QRCodes?.length ? (
      <LegacyCard sectioned>
        <EmptyState
          heading="Create unique QR codes for your product"
          action={{
            content: "Create QR code",
            onAction: () => navigate("/api/shopify/qr/create"),
          }}
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        >
          <p>
            Allow customers to scan codes and buy products using their phones.
          </p>
        </EmptyState>
      </LegacyCard>
    ) : null;

  return (
    <Page fullWidth={!!qrCodesMarkup}>
      <TitleBar
        title="Welcome to MeQr"
        primaryAction={{
          content: "Create QR code",
          onAction: () => navigate("/api/shopify/qr/create"),
        }}
      />
      <Layout>
        <Layout.Section>
          {loadingMarkup}
          {qrCodesMarkup}
          {emptyStateMarkup}
        </Layout.Section>
      </Layout>
    </Page>
  );
}
